import { UserPermissions } from '../constants/constants'

export const hasPermissionCheck = (
    userPermissions: UserPermissions[],
    required: UserPermissions | UserPermissions[],
): boolean => {
    if (!required) return false

    if (Array.isArray(required)) {
        return required.some((perm) => userPermissions.includes(perm))
    }

    return userPermissions.includes(required)
}
